<template>
  <v-card>
    <v-img
      :src="supportHeartImage"/>
    <v-container
      fulid>
      <v-row
        justify=center>
        <v-col
          cols=auto>
          <h3>先着100名!!Prosense公式アカウントの</h3>
        </v-col>
      </v-row>
      <v-row
        justify=center>
        <v-col
          cols=auto>
          <h3>お友だち限定コンテンツ！</h3>
        </v-col>
      </v-row>
      <v-row
        justify=center>
        <v-col
          cols=auto
          >
          <h2
            class="emphasis--phrase">Prosense公式マインクラフトプログラミング教科書のご案内</h2>
        </v-col>
      </v-row>
      <v-row
        justify=center>
        <v-col
          cols=auto>
          <h2
            class="emphasis--phrase">無料配布実施中</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols=12>
          Prosenseの講師陣が執筆したマインクラフトで学ぶプログラミングの公式テキストを、<b>今なら無料</b>でご案内！！Prosense公式アカウントを友だち追加して、無料体験授業を申し込み頂いたお客様に先着100名様にテキストを無料配布しております。
        </v-col>
        <v-col
          cols=12>
          <ul>
            <li>Prosenseの授業でも使用している公式テキスト</li>
            <li>初心者でも安心のわかりやすさ</li>
            <li>有料コンテンツ並のボリューム</li>
          </ul>
        </v-col>
        <v-col
          cols=12
        >
          ※当キャンペーンは予告なく終了する可能性がございます。
        </v-col>
        <v-col
          cols=12>
          LINEお友だち登録は<a class="font-weight-bold" href="/redirect/to-line" target="_blank">コチラ</a>から。
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import SupportHeartImage from '@/assets/img/support_heart.jpg'

export default {
  data: () => {
    return {
      supportHeartImage: SupportHeartImage
    }
  }
}
</script>

<style scoped>
.emphasis--phrase {
  background: linear-gradient(transparent 60%, #ffff66 60%)
}
</style>